module.exports = __webpack_public_path__ + "img/pateo-de-alfama.9f40d0d1.jpg";